import "./main-message.scss";

type MainMessageType = "error" | "warning" | "info";

type MainMessageProps = {
	type: MainMessageType; // Тип сообщения
	text: string; // Текст сообщения
};

const messageIconByType: Record<MainMessageType, string> = {
	error: "/img/icons/error.png",
	warning: "/img/icons/warning.png",
	info: "/img/icons/info.png",
};

const messageIconAltByType: Record<MainMessageType, string> = {
	error: "Ошибка",
	warning: "Предупреждение",
	info: "Информация",
};

export const MainMessage = ({ type, text }: MainMessageProps) => {
	const iconSrc = messageIconByType[type];
	const iconAlt = messageIconAltByType[type];
	const modifierClass = `main-message--${type}`;

	return (
		<div className={`main-message ${modifierClass}`} role="status" aria-live="polite">
			<img className="main-message__icon" src={iconSrc} alt={iconAlt} />
			<p className="main-message__text">{text}</p>
		</div>
	);
};
